import React, { FunctionComponent } from 'react';
import { SxProps, Tab, TabProps, Tabs, TabsProps } from '@mui/material';

export interface ITabItem {
  index: number;
  key: string;
  title: string;
}

interface TabBarProps {
  selectedTab?: ITabItem;
  tabs: ITabItem[];
  tabsProps?: TabsProps;
  tabProps?: TabProps;
  onChange: (
    event: React.SyntheticEvent<Element, Event>,
    value: number
  ) => void;
}

export const defaultTabContainerStyles = {
  backgroundColor: '#F1F5F9',
  padding: '6px',
  borderRadius: '15px',
  alignItems: 'center',
};

export const defaultTabRootStyles = {
  p: '10px',
  backgroundColor: 'transparent',
  fontWeight: 600,
  fontSize: '14px',
  borderRadius: '11px',
  color: '#1E293B',
  minHeight: 'unset',
  minWidth: 'unset',
};

const a11yProps = (index: number) => {
  return {
    id: `tabItem-${index}`,
    'aria-controls': `tabPanel-${index}`,
  };
};

export const TabBar: FunctionComponent<TabBarProps> = ({
  selectedTab,
  tabs = [],
  tabsProps = {
    sx: {},
  },
  tabProps = {
    sx: {},
  },
  onChange = undefined,
}) => {
  return (
    <Tabs
      value={selectedTab?.index || 0}
      TabIndicatorProps={{ hidden: true }}
      {...tabsProps}
      onChange={onChange}
      sx={{
        ...defaultTabContainerStyles,
        ...tabsProps.sx,
      }}
    >
      {tabs.map((tab, index) => {
        // const isSelected = tab.index === selectedTab?.index || 0;

        const tabStyles: SxProps = {
          '&.MuiButtonBase-root': {
            ...defaultTabRootStyles,
          },
          '&.Mui-selected': {
            backgroundColor: '#1E293B',
            color: '#F8FAFC',
          },
          height: 'unset',
          minHeight: 'unset',
        };

        return (
          <Tab
            key={tab.key}
            color="inherit"
            label={tab.title}
            {...a11yProps(index)}
            {...tabProps}
            sx={{ ...tabStyles, ...tabProps.sx }}
          />
        );
      })}
    </Tabs>
  );
};

export default TabBar;
